import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';

import { OpenSearchFromHeader } from '@layout/infrastructure/state/layout.actions';

@Component({
    selector: 'header-search',
    standalone: true,
    imports: [TranslateModule],
    template: `
        <button class="btn search-bar text-l topbar-link btn-search" (click)="openSearch()">{{ 'header_search' | translate }}</button>
    `,
})
export class HeaderSearchComponent {
    private readonly store = inject(Store);

    public openSearch(): void {
        if (typeof hj !== 'undefined') {
            hj('tagRecording', ['buscador']);
        }
        this.store.dispatch(OpenSearchFromHeader({ from: 'header' }));
    }
}
